import React from 'react';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { addDays } from 'date-fns';
import { useState } from 'react';
import { DateRange } from 'react-date-range';

function DateRangeCalendar({setDateRange, dateRange}) {
  return (
    
  <DateRange
  editableDateInputs={true}
  onChange={(item) => {
    setDateRange([item.selection]);
  }}
  moveRangeOnFirstSelection={false}
  ranges={dateRange}
/>

  )
}


export default DateRangeCalendar